<div class="bar" [class.empty]="_barsInfo | acFunc: isEmpty" [title]="title" [style.grid-template-columns]="fractions">
    <div class="bar-info" *ngFor="let barInfo of _barsInfo" [style.background-color]="barInfo.color"></div>
</div>
